import React, { ReactNode,createContext, useReducer, type Dispatch, useContext } from 'react';

 //Interfaces
 interface Props {
    children?: ReactNode
    // any props that come into the component
  }

export interface Skid{
    id:number
    name:string,
    displayName:string,
    circulationTime:number,
    timezone:string,
    secondName:string|null,
    secondDisplayName:string|null,
    status?:string
    unit?:string
    interface?:string
    header?:string,
    operator?:string,
    country?:string,
    imsContact?:string,
    wellName?:string,
    field?:string,
    rigName?:string
    rigType?:string
    supervisor?:boolean
}
export function determineDisplayName(skid:Skid):string{
  if (!isEmptyValue(skid.displayName)){
    return skid.displayName
  }
  return skid.name
}
function isEmptyValue(value:string) {
if (value === null || value === undefined) return true;
return String(value).trim() === "";
}
export interface Action{
    type:'addSkidWithConfig' | 'removeSkidWithConfig'| 'addSkidsWithConfig'   //update skid is just adding the existing skid as no duplicates allowed in map
    skid:Skid|null,
    skids:Map<string,Skid>|null
}


export const skidsWithConfigContext = createContext<Map<string,Skid>>(new Map<string,Skid>())
const skidsWithConfigDispatchContext = createContext<Dispatch<any> | null>(null)

//export functions

export function useSkidsWithConfig(){
    return useContext(skidsWithConfigContext)
  }
export function useSkidsWithConfigDispatch(){
    return useContext(skidsWithConfigDispatchContext)
  }

export default function SkidsWithConfigProvider({ children }:Props):React.JSX.Element {
    const [skids, dispatch] = useReducer(SkidsWithConfigReducer, new Map<string,Skid>());
    return (
       <skidsWithConfigContext.Provider value={skids}>
         <skidsWithConfigDispatchContext.Provider value={dispatch}>
           {children}
         </skidsWithConfigDispatchContext.Provider>
       </skidsWithConfigContext.Provider>
       );

}

function SkidsWithConfigReducer(skids:Map<string,Skid>,action:Action){
    switch(action.type){
        case'addSkidWithConfig':{
            skids.set(determineDisplayName(action.skid),action.skid)
            return skids
        }
        case'removeSkidWithConfig':{
            skids.delete(action.skid.name)
            return skids
        }
        case'addSkidsWithConfig':{
          
          console.log("adding skids with config:",action.skids)
          if(!skids){
          return action.skids
          }
          console.log("adding:",action.skids, "to:",skids)
          if(action.skids){
             action.skids.forEach(skid => {
            console.log("adding skid",skid.name,skid)
            skids.set(determineDisplayName(skid),skid)
          });
          console.log("new skids:",skids)
          }
          console.log("returning skids")
          return skids
        }
    }
}


   